import userImg from "../images/user.jpg";
import { useEffect, useState } from "react";
import { authServices } from "authentication/services/auth.service";
import { ISession } from "authentication/domain/ISession";

interface IProps {
  activeSession: ISession;
};

const ActiveSession = ({ activeSession }: IProps) => {
  const [img, setImg] = useState<string | null>(null);

  async function getImg() {
    try {
      const image = await authServices.getProfilePictureForSpecificUser(activeSession.username);
      setImg(image);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getImg();
  }, [])

  return (
    <div className="item">
      <img src={img ? img : userImg} alt="img" />
      <div>{activeSession.username}</div>
    </div>
  );
};

export default ActiveSession;
